module.exports = __webpack_public_path__ + "static/media/052-witch.89324892.svg";